import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            Gemeinsam meistern wir Ihre größten Herausforderungen
          </h1>

          <div className="hero-boxes">
            <div className="hero-box hero-box--problem">
              <span className="hero-box-tag">Problem</span>
              <p className="hero-box-text">Fachkräftemangel und drohender Wissensverlust limitieren Ihren Geschäftserfolg</p>
            </div>
            <div className="hero-box hero-box--solution">
              <span className="hero-box-tag">Lösung</span>
              <p className="hero-box-text">Wir automatisieren Ihre Geschäftsprozesse und sichern Ihr Expertenwissen mit KI</p>
            </div>
            <div className="hero-box hero-box--result">
              <span className="hero-box-tag">Ergebnis</span>
              <p className="hero-box-text">Mehr Effizienz, zukunftssichere Prozesse und generationenübergreifendes Wachstum</p>
            </div>
          </div>

          <p className="hero-cta-text">
            Nutzen Sie jetzt Ihr volles Potenzial durch den kostenlosen Ratgeber und ein kostenloses Beratungsgespräch.
          </p>

          <div className="hero-buttons">
            <a href="#contact" className="btn btn-primary">
              Kostenloser Ratgeber
            </a>
            <a href="#contact" className="btn btn-secondary"
               onClick={() => sessionStorage.setItem('autoBeratung', 'true')}>
              Beratungsgespräch
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
